import { createContext, useState, useRef, ReactNode } from 'react';

import { QuickActionFunctionType } from '@components/suggestions/quickActions/types';

// Define the type for our context
type FunctionContextType = {
  actionFunction: () => Promise<QuickActionFunctionType>;
  setActionFunction: (fn: () => Promise<QuickActionFunctionType>) => void;
  disabled: boolean;
  setDisabled: React.Dispatch<React.SetStateAction<boolean>>;
};

// Create Context
const SuggestionsContext = createContext<FunctionContextType | null>(null);

// Provider Component
export const SuggestionsProvider = ({ children }: { children: ReactNode }) => {
  const actionFunctionRef = useRef<() => Promise<QuickActionFunctionType>>(() => Promise.reject());
  const [disabled, setDisabled] = useState(true); // default to disabled

  const setActionFunction = (fn: () => Promise<QuickActionFunctionType>) => {
    actionFunctionRef.current = fn;
  };

  const actionFunction = () => actionFunctionRef.current();

  return (
    <SuggestionsContext.Provider
      value={{ actionFunction, setActionFunction, disabled, setDisabled }}
    >
      {children}
    </SuggestionsContext.Provider>
  );
};

export default SuggestionsContext;
